import { Outlet, Navigate } from "react-router";
import { useXNGSelector } from "./context/store";
import { selectUser } from "./context/slices/userProfileSlice";
import { ROUTES_XLOGS } from "./constants/URLs";
import SidebarLayout from "./layouts/SidebarLayout";
import useMsbSidebarButtons from "./views/msb/constants/msb_sidebar_btns";
import { isAtLeastEmployee } from "./utils/msb_role";

// The account-agnostic MSB operator zone (XLOGS-205). Unlike the admin area,
// this gate is the msb_role ladder ONLY — district delegated/executive admins
// never pass it, and nothing inside is scoped to the logged-in client. The
// zone opens at ≥ MsbEmployee behind MsbAdminPortalActive; each section then
// rides its own flag (Billing / Imports / District Management) and pages
// apply their own tier on top (actions ≥ MsbAdmin, imports writes SuperAdmin).
export default function MsbProtectedRoute() {
  const user = useXNGSelector(selectUser);
  const msbAdminPortalActive = useXNGSelector(
    (state) => state.featureFlags.flags["MsbAdminPortalActive"],
  );
  const msbButtons = useMsbSidebarButtons();

  return isAtLeastEmployee(user) && msbAdminPortalActive ? (
    <SidebarLayout sidebarContent={msbButtons} content={<Outlet />} persistKey="msb" />
  ) : (
    <Navigate to={ROUTES_XLOGS.calendar} replace />
  );
}
